import { AxiosConfig } from '../../componentes/axiosConfig';

export class DeletarExpedienteRastreavel {
    constructor() {
        this._axios = (new AxiosConfig()).instanciaAxios();

        this._idContainerExpediente  = 'container-expediente-rastreavel';
        this._classDeletarExpediente = 'deletar-expediente-rastreavel';
    }

    executar() {
        const containerExpediente = $(`#${this._idContainerExpediente}`);
        if (containerExpediente.length === 0) {
            return;
        }

        const _this = this;
        containerExpediente.on('click', `.${this._classDeletarExpediente}`, function (event)  {
            event.preventDefault();
            const urlRequisicao = $(this).attr('href');
            if (urlRequisicao) {
                _this._deletar(urlRequisicao);
            }
        });
    }

    /**
     * @param {string} urlRequisicao
     * @private
     */
    _deletar(urlRequisicao) {
        try {
            const containerExpediente = document.getElementById(this._idContainerExpediente);
            swal({
                title       : 'Você tem certeza?',
                text        : 'Depois de excluido, não poderar mais ser recuperado',
                icon        : 'warning',
                buttons     : true,
                dangerMode  : true,
            })
            .then((deletar) => {
                if (deletar) {
                    this._axios.get(urlRequisicao)
                    .then((response) => {
                        if (response.data) {
                            containerExpediente.innerHTML = response.data;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
                }
            });
        }
        catch (error) {
            console.log(error);
        }
    }
}
